import {ItemModelType} from "@stores/WorkspaceStore";
import {Item} from "../../@types/Item";
import {updateItemDB} from "./updateItem";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "@stores/UserSessionState";

export const confirmAcknowledgment = async (
    services: CrudServices,
    userState: UserSessionState,
    itemMST: ItemModelType
) => {
    if (!userState.currentUserId) {
        return;
    }

    itemMST.markAcknowledgement(userState.currentUserId)

    const fieldsToUpdate: Partial<Item> = {
        acknowledgement: itemMST.acknowledgement,
    }

    await updateItemDB(services, userState.dsManager!, itemMST.workspaceId, itemMST.id, fieldsToUpdate)
}
